module.exports = __webpack_public_path__ + "img/文章头图.11e71259.png";